import { Button, styled } from '@mui/material';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
          padding: ${theme.spacing(0, 1)};
          height: ${theme.spacing(7)};
  `
);
export default UserBoxButton;
